import * as styles from 'components/Skeleton/Skeleton.css';
import { vars } from 'styles/variables.css';

function LoadingSkeleton() {
  return (
    <div className={styles.skeletonContainer} style={{ marginBottom: vars.space[8] }}>
      <div className={styles.skeletonComponent} style={{ margin: vars.space[40], marginBottom: vars.space[8], width: '300px' }} />
      <div className={styles.skeletonComponent} style={{ marginBottom: vars.space[40], width: '180px' }} />
      <div className={styles.skeletonComponent} style={{ marginBottom: vars.space[18], width: '250px', height: '40px' }} />
      <div className={styles.skeletonComponent} style={{ marginBottom: vars.space[18], width: '250px', height: '40px' }} />
      <div className={styles.skeletonComponent} style={{ marginBottom: vars.space[18], width: '250px', height: '40px' }} />
      <div className={styles.skeletonComponent} style={{ margin: vars.space[16], marginBottom: vars.space[16], width: '280px' }} />
    </div>
  );
}

export default LoadingSkeleton;
